// extracted by mini-css-extract-plugin
export default {"heading":"BiddingStrategy_heading__0W34P","wrapper":"BiddingStrategy_wrapper__qWlPv","bidStrategyContainer":"BiddingStrategy_bidStrategyContainer__OTbMF"};